import { render, staticRenderFns } from "./ResultsView.vue?vue&type=template&id=0729e2a7&lang=html&"
import script from "./ResultsView.vue?vue&type=script&lang=js&"
export * from "./ResultsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports